

import { LayoutCrearDoc } from "../../layouts";
import { TablaListadoUsuarios } from "../components";
import { useNavigate } from "react-router-dom";
import { useListUserXRole } from "../../../hooks/cache";
import { BuscadorXTermino } from "../../components/buscadores";
import { CargandoMedio } from "../../components";



export const ListadoUsuarios = () => {


    const navigate = useNavigate();
    const { data, isLoading, page, termino, chagePage, chageTermino } = useListUserXRole(['SUPERADMIN', 'ADMIN', 'ADMINISTRADOR']);


    
    const handleNavegar = () => {
        navigate(`/super/crearUsuario`);
    }


    return (


        <LayoutCrearDoc titulo='Listado Administradores' funcion={ handleNavegar }>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de administradores..." />
            :   <>
                <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="usuario" playhol="nombre ciudad movil cedula" />
                <TablaListadoUsuarios data={data || []} chagePage={chagePage} page={page} />
                </>
            }
        </LayoutCrearDoc>

    )
}
